export const SANCTIONS_OBJECTS_DETECT_LIST: {[key:string]: {label: string}} = {
  'sanctions': {
    label: 'Sanctions',
  },
  'addressEntity': {
    label: 'Address Entity',
  },
  'positionOccupancies': {
    label: 'Position Occupancies',
  },
}

export const checkSanctionObject = (objectName: string, objectData: any[]): {label: string} | undefined=> {
  if(!objectName || !objectData) {
    return undefined;
  }
  // const objectFromKnownList = SANCTIONS_OBJECTS_DETECT_LIST[objectName];
  //
  // if(objectFromKnownList) {
  //   return objectFromKnownList;
  // }

  const objectWithId = objectData.find((item) => item.id && item.id !== '');
  const objectWithSchema = objectData.find((item) => item.schema && item.schema !== '');

  if(objectWithId || objectWithSchema) {
    return {
      label: objectWithSchema.schema
    };
  }

  return undefined;
}
